<template>
    <v-simple-table class="rounded-lg simple-table elevation-1" dense
        :class="!$slots['action-bar'] ? 'simple-table--round-top' : ''">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left" v-for="(header,index) in headers" :key="index">
                {{ header.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.id" >
              <td v-for="(header,index) in headers" :key="index">
                <template v-if="header.type && header.type=='html'">
                    <div :class="header.type && header.type=='html' ? 'd-flex align-items-center gap-2' : ''">
                        <span v-html="item[header.value]"></span>
                        <span v-if="item[header.value]=='' && invoiceRegenerable">
                            <v-btn @click="clickColActionBtn(regenerateInvoiceButton.action, item, tableRefName)" 
                                color="primary" 
                                icon 
                                :loading="(item.loading && item.loading[regenerateInvoiceButton.action]) || false"
                                v-if="!regenerateInvoiceButton.visibility || item[regenerateInvoiceButton.visibility]">
                                <v-icon>{{ regenerateInvoiceButton.icon }}</v-icon>
                            </v-btn>
                        </span>
                        <v-btn v-if="item.charges_count > 0 && item.invoices_list_pdfs.length > 0 && item[header.value]" @click="clickColInvoicesListBtn(item)" 
                            color="primary" icon
                            :loading="item.loading || false">
                            <v-icon>mdi-eye-plus-outline</v-icon>
                        </v-btn>
                    </div>
                </template>
                <!-- Columna "actions" con los botones de acciones-->
                <template v-else-if="header.value=='actions'">    
                    <div class="d-flex align-items-center gap-2">     
                        <v-tooltip top v-for="actionBtn in actionBtnList">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="clickColActionBtn(actionBtn.action, item, tableRefName)" 
                                    color="primary" 
                                    icon 
                                    v-bind="attrs" 
                                    v-on="on"                                
                                    :loading="(item.loading && item.loading[actionBtn.action]) || false"
                                    v-if="isActionVisible(actionBtn, item)">
                                    <v-icon>{{ actionBtn.icon }}</v-icon>
                                </v-btn>
                            </template>
                            <span>{{actionBtn.name}}</span>
                        </v-tooltip>
                    </div>
                </template>
                <template v-else-if="header.value=='total_extra_users'">    
                    <div class="d-flex align-items-center">
                        <p class="text-nowrap m-0">{{ item[header.value] }}</p>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="clickAddPaidUsers(item)" color="primary" icon v-bind="attrs" v-on="on"
                                v-if="!item.is_finished && item.is_latest"
                                :loading="(item.loading && item.loading[actionBtn.action]) || false">
                                    <v-icon>mdi-account-multiple-plus-outline</v-icon>
                                </v-btn>
                            </template>
                        <span>Añadir usuarios</span>
                        </v-tooltip>
                    </div>
                </template>
                <template v-else-if="header.type && header.type=='link' && header.link_text">
                    <p v-if="item[header.value]"><a :href="item[header.value]">{{ header.link_text }}</a></p>
                </template>
                <template v-else>
                    {{ item[header.value] }}
                </template>
              </td>
            </tr>
          </tbody>
        </template>
    </v-simple-table>
</template>

<script>
import { client } from "@/api/client"

export default {
    name: 'AppSimpleTableWithApi',

    props: {
        headers: {
            type: Array,
            default: [],
        },
        url: {
            type: String,
            required: true
        },
        tableRefName: {
            type: String,
            required: true
        },  
        actionBtnList: {
            type: Array,
            default() {
                 return [];
            }
        },
        invoiceRegenerable: {
            type: Boolean,
            default: false
        },
        regenerateInvoiceButton: {
            type: Object,
            default() {
                return {'name': 'Regenerar Factura', 'action': 'regenerate_invoice', 'icon': 'mdi-refresh', 'visibility': 'regenerate_visibility' };
            }
        },
        api_params: {
            type: Object,
            default: undefined,
        },
        loading:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            items: []
        }
    },
    methods: {
        getItems() {
            return new Promise((resolve, reject) => {
                this.loadingItems = true;
                let params = {};
                for (let key in this.api_params) {
                    params[key] = this.api_params[key];
                }
                client.get(this.url,{params: params}).then(response => {
                    this.items = response.data.results;
                    resolve()
                }).catch(error => {
                    reject(error);
				});
            });
        },
        clickColActionBtn(action, item, tableRef) {
            this.$emit('click-col-action-btn', action, item, tableRef);
        },
        clickColInvoicesListBtn(item) {
            this.$emit('click-col-invoice-list-btn', item);
        },
        clickAddPaidUsers (item) {
            this.$emit('click-col-add-paid-users', item);
        },
		isActionVisible(actionBtn, item) {
			function getNestedValue(obj, path) {
				return path.split('.').reduce((acc, key) => acc && acc[key], obj);
			}
			const visibility = actionBtn.visibility;
			if (!visibility) return true;

			if (Array.isArray(visibility)) {
				return visibility.every(path => Boolean(getNestedValue(item, path)));
			}
			return Boolean(getNestedValue(item, visibility));
		}
    },
    mounted() {
        this.getItems();
    },
}
</script>

<style scoped>
.simple-table {
    background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white) !important;
}

::v-deep.simple-table thead>tr:not(.simple-table__action-bar)>th {
    background-color: var(--v-primaryLight-base) !important;
    border-radius: 0 !important;
    color: var(--v-primary-base) !important;
}

::v-deep.simple-table.simple-table--round-top thead>tr:not(.simple-table__action-bar)>th:first-of-type {
    border-radius: 0.5rem 0 0 0 !important;
}

::v-deep.simple-table.simple-table--round-top thead>tr:not(.simple-table__action-bar)>th:last-of-type {
    border-radius: 0 0.5rem 0 0 !important;
}

::v-deep.simple-table tbody>tr>td {
    background-color: #FFF !important;
}

::v-deep.simple-table tbody>tr>td:not(:last-of-type) {
    border-right: 1px solid var(--v-primary-base);
}
.align-items-center{
    align-items: center
}
.text-nowrap{
    white-space: nowrap;
    overflow: hidden;
}
.m-0{ margin: 0 !important;}
</style>